import { render, staticRenderFns } from "./ChangeFormula.vue?vue&type=template&id=efb357cc&scoped=true"
import script from "./ChangeFormula.vue?vue&type=script&lang=js"
export * from "./ChangeFormula.vue?vue&type=script&lang=js"
import style0 from "./ChangeFormula.vue?vue&type=style&index=0&id=efb357cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb357cc",
  null
  
)

export default component.exports